import React, { useEffect, useMemo, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { approveReject, displaySuccess, getProviderList } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactPaginate from 'react-paginate';
import { Modal } from 'react-bootstrap';
import './style.css';

const AVATAR_PALETTE = [
	'#c22627', '#5a4cdb', '#d6336c', '#2b6cb0', '#e8590c',
	'#0ca678', '#7048e8', '#1098ad', '#f08c00', '#37b24d',
];

const colorForName = (name = '') => {
	let hash = 0;
	for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
	return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

const initialsOf = (name = '') => {
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
	if (parts[0]) return parts[0].substring(0, 2).toUpperCase();
	return '?';
};

const formatExperience = (exp) => {
	if (exp === undefined || exp === null || exp === '') return null;
	const str = String(exp).trim();
	if (/year/i.test(str)) return str;
	const n = parseInt(str, 10);
	if (!isNaN(n)) return `${n} ${n === 1 ? 'Year' : 'Years'}`;
	return str;
};

const genderClass = (gender) => {
	const g = (gender || '').toLowerCase();
	if (g === 'female') return 'gender-pill gender-female';
	if (g === 'male') return 'gender-pill gender-male';
	return 'gender-pill gender-other';
};

const statusClass = (status) => {
	const s = (status || '').toLowerCase();
	if (s === 'approved' || s === 'approve') return 'status-pill status-approved';
	if (s === 'rejected' || s === 'reject') return 'status-pill status-rejected';
	return 'status-pill status-pending';
};

const YogaTrainers = (props) => {
	const [users, setUsers] = useState([]);
	const [count, setCount] = useState(10);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(0);
	const [userId, setUserId] = useState('');
	const [approve, setApprove] = useState(false);
	const [reject, setReject] = useState(false);
	const [detailModal, setDetailModal] = useState(null);
	const [search, setSearch] = useState('');
	const [statusFilter, setStatusFilter] = useState('all');

	const getList = async (perPage = count, selectedPage = 1) => {
		props.toggleLoader(true);
		const response = await getProviderList(perPage, selectedPage);
		setTotal(response?.metadata?.totalPage);
		setPage(response?.metadata?.page);
		setUsers(response?.data || []);
		props.toggleLoader(false);
	};

	useEffect(() => {
		getList(count, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handlePageClick = async (e) => {
		const selectedPage = e.selected + 1;
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
		getList(count, selectedPage);
	};

	const handlePerPageChange = (e) => {
		const next = parseInt(e.target.value, 10);
		setCount(next);
		getList(next, 1);
	};

	const approveRejectTrainer = async (status) => {
		const res = await approveReject(userId, status);
		if (res.status === 200) {
			displaySuccess(
				status === 'approve'
					? 'Yoga trainer approved successfully.'
					: 'Yoga trainer rejected successfully.'
			);
			getList(count, page);
		}
	};

	const filteredUsers = useMemo(() => {
		const q = search.trim().toLowerCase();
		return (users || []).filter((u) => {
			if (statusFilter !== 'all') {
				const s = (u?.status || 'pending').toLowerCase();
				if (statusFilter === 'pending' && s !== 'pending') return false;
				if (statusFilter === 'approved' && s !== 'approved' && s !== 'approve') return false;
				if (statusFilter === 'rejected' && s !== 'rejected' && s !== 'reject') return false;
			}
			if (!q) return true;
			const name = (u?.name || '').toLowerCase();
			const email = (u?.email || '').toLowerCase();
			const phone = (u?.phone_number || '').toLowerCase();
			return name.includes(q) || email.includes(q) || phone.includes(q);
		});
	}, [users, search, statusFilter]);

	return (
		<div className="g-sidenav-show bg-gray-100">
			<div id="wrapper">
				<Leftbar />

				<main className="main-content border-radius-lg">
					<Topbar />
					<div className="header bg-primary pb-6">
						<div className="container-fluid">
							<div className="header-body">
								<div className="row align-items-center py-4">
									<div className="col-lg-6 col-7">
										<nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
											<ol className="breadcrumb breadcrumb-links breadcrumb-dark">
												<li className="breadcrumb-item">
													<Link to="/dashboard"><i className="fas fa-home" /></Link>
												</li>
												<li className="breadcrumb-item">
													<a href="#">Yoga trainers</a>
												</li>
											</ol>
										</nav>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="container-fluid mt--6"></div>
					<div className="container-fluid">
						<div className="card gynac-card">
							<div className="gynac-card-header">
								<h3 className="gynac-title">
									Yoga Trainers Listing
									<span className="gynac-count-chip">
										{filteredUsers.length}{search || statusFilter !== 'all' ? ` of ${users.length}` : ''}
									</span>
								</h3>

								<div className="gynac-toolbar">
									<div className="gynac-search">
										<i className="fas fa-search search-icon" />
										<input
											type="text"
											placeholder="Search name, email or phone"
											value={search}
											onChange={(e) => setSearch(e.target.value)}
										/>
									</div>
									<div className="gynac-filter">
										<select
											value={statusFilter}
											onChange={(e) => setStatusFilter(e.target.value)}
											aria-label="Filter by status"
										>
											<option value="all">All status</option>
											<option value="pending">Pending</option>
											<option value="approved">Approved</option>
											<option value="rejected">Rejected</option>
										</select>
									</div>
									<Link to="/add-gynac">
										<button className="btn gynac-add-btn">
											<i className="fas fa-plus" style={{ marginRight: 6 }} />
											Add Yoga Trainer
										</button>
									</Link>
								</div>
							</div>

							<div className="table-responsive">
								<table className="gynac-table">
									<colgroup>
										<col className="gynac-col-doctor" />
										<col className="gynac-col-contact" />
										<col className="gynac-col-credentials" />
										<col className="gynac-col-description" />
										<col className="gynac-col-action" />
									</colgroup>
									<thead>
										<tr>
											<th>Trainer</th>
											<th>Contact</th>
											<th>Credentials</th>
											<th>Description</th>
											<th style={{ textAlign: 'center' }}>Status</th>
										</tr>
									</thead>
									<tbody>
										{filteredUsers.map((user) => {
											const name = user?.name || '—';
											const initials = initialsOf(name);
											const avatarColor = colorForName(name);
											const exp = formatExperience(user?.experience);
											const desc = user?.description || '';
											const isLongDesc = desc.length > 120;
											const status = (user?.status || 'pending').toLowerCase();
											const isPending = status === 'pending';

											return (
												<tr key={user?._id}>
													<td data-label="Trainer">
														<div className="doctor-cell">
															{user?.image ? (
																<img
																	src={user.image}
																	alt={name}
																	className="doctor-avatar"
																/>
															) : (
																<span
																	className="doctor-avatar-fallback"
																	style={{ background: avatarColor }}
																>
																	{initials}
																</span>
															)}
															<div className="doctor-info">
																<span className="doctor-name" title={name}>{name}</span>
																{user?.email && (
																	<a
																		href={`mailto:${user.email}`}
																		className="doctor-email"
																		title={user.email}
																	>
																		{user.email}
																	</a>
																)}
																{user?.gender && (
																	<div className="doctor-gender-row">
																		<span className={genderClass(user.gender)}>{user.gender}</span>
																	</div>
																)}
															</div>
														</div>
													</td>

													<td data-label="Contact">
														{user?.phone_number ? (
															<div className="contact-line">
																<i className="fas fa-phone fa-flip-horizontal" />
																{user.phone_number}
															</div>
														) : (
															<span className="text-muted">—</span>
														)}
													</td>

													<td data-label="Credentials">
														<div className="cred-line">
															{exp ? (
																<span className="cred-experience">
																	<i className="fas fa-briefcase" />
																	{exp}
																</span>
															) : (
																<span className="text-muted">No experience</span>
															)}
															{user?.education && (
																<span className="cred-education">{user.education}</span>
															)}
														</div>
													</td>

													<td data-label="Description">
														{desc ? (
															<>
																<div className="desc-text">{desc}</div>
																{isLongDesc && (
																	<span
																		className="desc-view-more"
																		onClick={() => setDetailModal({ title: 'Description', text: desc, subtitle: name })}
																	>
																		View More
																	</span>
																)}
															</>
														) : (
															<span className="text-muted">—</span>
														)}
													</td>

													<td data-label="Status" style={{ textAlign: 'center' }}>
														{isPending ? (
															<div className="action-stack">
																<button
																	className="btn-pill btn-approve"
																	onClick={() => { setApprove(true); setUserId(user?._id); }}
																>
																	Approve
																</button>
																<button
																	className="btn-pill btn-reject"
																	onClick={() => { setReject(true); setUserId(user?._id); }}
																>
																	Reject
																</button>
															</div>
														) : (
															<span className={statusClass(user?.status)}>{user?.status}</span>
														)}
													</td>
												</tr>
											);
										})}

										{!filteredUsers.length && (
											<tr>
												<td colSpan={5}>
													<div className="gynac-empty">
														<i className="fas fa-spa" />
														<div className="gynac-empty-text">No yoga trainers found</div>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>

							{users.length > 0 && (
								<div className="gynac-footer">
									<div className="gynac-per-page">
										<span>Rows per page</span>
										<select value={count} onChange={handlePerPageChange}>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
										</select>
									</div>

									<div className="paginate-css" style={{ margin: 0 }}>
										<ReactPaginate
											previousLabel="<"
											nextLabel=">"
											breakLabel="..."
											pageCount={total}
											forcePage={page > 0 ? page - 1 : 0}
											marginPagesDisplayed={1}
											pageRangeDisplayed={3}
											onPageChange={handlePageClick}
											containerClassName="pagination"
											activeClassName="active"
										/>
									</div>
								</div>
							)}
						</div>
					</div>

					{approve && (
						<SweetAlert
							warning
							showCancel
							confirmBtnText="Yes"
							title="Are you sure?"
							onConfirm={() => {
								approveRejectTrainer('approve');
								setApprove(false);
							}}
							onCancel={() => setApprove(false)}
						>
							You want to approve this Yoga trainer.
						</SweetAlert>
					)}

					{reject && (
						<SweetAlert
							warning
							showCancel
							confirmBtnText="Yes"
							title="Are you sure?"
							onConfirm={() => {
								approveRejectTrainer('reject');
								setReject(false);
							}}
							onCancel={() => setReject(false)}
						>
							You want to reject this Yoga trainer.
						</SweetAlert>
					)}

					<Modal show={!!detailModal} onHide={() => setDetailModal(null)} centered>
						<Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
							<div>
								<h5 className="mb-0" style={{ fontWeight: 700 }}>{detailModal?.title}</h5>
								{detailModal?.subtitle && <small className="text-muted">{detailModal.subtitle}</small>}
							</div>
							<button
								type="button"
								style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}
								onClick={() => setDetailModal(null)}
							>
								&times;
							</button>
						</Modal.Header>
						<Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', lineHeight: 1.7, color: '#333', maxHeight: '70vh', overflowY: 'auto' }}>
							{detailModal?.text}
						</Modal.Body>
					</Modal>
				</main>
			</div>
		</div>
	);
};

export default connect(null, { toggleLoader })(YogaTrainers);
